/**
 * ThemePage
 */

import React from 'react';
import { ThemePageModel } from 'types/pages';
import EpiContentArea from 'components/EpiContentArea';
import Breadcrumb from 'components/Breadcrumb';

/** Page template for an theme page. */
const ThemePage: React.FC<ThemePageModel> = ({
	breadcrumbs,
	translations,
	topContentArea,
	contentArea,
	_properties = {},
}) => (
	<main id="main-content">
			{breadcrumbs && (
				<Breadcrumb
					links={breadcrumbs}
					label={translations.breadcrumbsLabel}
					withBorder
				/>
			)}
		<EpiContentArea
			{..._properties?.topContentArea}
			content={topContentArea}
			isPageHeader={true}
		/>
		<EpiContentArea {..._properties?.contentArea} content={contentArea} />
	</main>
);

export default ThemePage;
